module.exports = __webpack_public_path__ + "static/media/flat2Modal.274ee841.jpg";